import React, {memo} from 'react';
import {Bar} from 'react-chartjs-2';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/styles';
import {
    Card,
    CardContent,
    Divider,
} from '@material-ui/core';

const initialData = {
    labels: ['reference week', 'comparison week'],
};

const useStyles = makeStyles(theme => ({
    root: {
        // minHeight: '400px',
    },
    cardContent: {
        height: '100%',
    },
    chartContainer: {
        position: 'relative',
        height: '100%',
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center',
    },
}));

const StackedChart = memo(props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const colorSets = [
        theme.palette.primary.light,
        theme.palette.secondary.light,
        theme.palette.error.light,
        theme.palette.warning.light,
        theme.palette.info.light,
        theme.palette.success.light,
        theme.palette.primary.main,
        theme.palette.secondary.main,
        theme.palette.error.main,
        theme.palette.warning.main,
        theme.palette.info.main,
        theme.palette.success.main,
    ];
    const borderColorSets = [
        theme.palette.primary.main,
        theme.palette.secondary.main,
        theme.palette.error.main,
        theme.palette.warning.main,
        theme.palette.info.main,
        theme.palette.success.main,
        theme.palette.primary.dark,
        theme.palette.secondary.dark,
        theme.palette.error.dark,
        theme.palette.warning.dark,
        theme.palette.info.dark,
        theme.palette.success.dark,
    ];
    const chartOptions = {
        // title: {
        //   display: true,
        //   text: 'Chart.js Bar Chart - Stacked',
        // },
        legend: {
            position: 'left',
        },
        tooltips: {
            mode: 'nearest',
            intersect: false,
        },
        responsive: true,
        scales: {
            xAxes: [
                {
                    stacked: true,
                    ticks: {
                        fontColor: theme.palette.text.secondary,
                    },
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                }],
            yAxes: [
                {
                    stacked: true,
                    ticks: {
                        fontColor: theme.palette.text.secondary,
                        beginAtZero: true,
                    },
                    gridLines: {
                        borderDash: [2],
                        borderDashOffset: [2],
                        color: theme.palette.divider,
                        drawBorder: false,
                        zeroLineColor: theme.palette.divider,
                    },
                }],
        },
    };
    const barChartData = (data) => {
        return {
            ...initialData,
            datasets: data.map((dataset, idx) => {
                return {
                    borderWidth: 1,
                    barThickness: 100,
                    backgroundColor: colorSets[idx],
                    borderColor: borderColorSets[idx],
                    ...data[idx],
                };
            }),
        };
    };

    if (!data) return null;

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Divider/>
            <CardContent className={classes.cardContent}>
                <div className={classes.chartContainer}>
                    <Bar
                        data={barChartData(data)}
                        options={chartOptions}
                    />
                </div>
            </CardContent>
        </Card>
    );
});

StackedChart.propTypes = {
    className: PropTypes.string,
    data: PropTypes.any,
};

export default StackedChart;
